import BasketMinBannerSFC from "./BasketMinBanner.vue";
export const BasketMinBanner = BasketMinBannerSFC;
